import { useEffect, useState } from 'react';
import { get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { change } from 'redux-form';
import { getCurrentSymbolSelector, getAccountTypeSelector } from '../selectors';
import { ACCOUNT_TYPE_TRADER } from 'modules/tradingCalculators/constants';

export const useSymbolLeverage = (form, symbols, leverageValues) => {
  const dispatch = useDispatch();
  const [symbolLeverage, setSymbolLeverage] = useState([]);
  const symbolSelector = getCurrentSymbolSelector(form);
  const accountTypeSelector = getAccountTypeSelector(form);

  const symbol = useSelector(symbolSelector);
  const accountType = useSelector(accountTypeSelector);

  useEffect(() => {
    const symbolConfig = symbols.find((s) => s.symbol === get(symbol, 'value', symbol));
    if (!symbolConfig) {
      setSymbolLeverage([]);
      return;
    }

    let leverage = leverageValues;
    if (accountType === ACCOUNT_TYPE_TRADER) {
      leverage = leverageValues.filter((l) => l.value <= symbolConfig.maxLeverage);
      leverage = [{ value: symbolConfig.maxLeverage, label: symbolConfig.maxLeverage }];
    }

    dispatch(change(form, 'leverage', leverage[0].value));
    setSymbolLeverage(leverage);
  }, [symbol, dispatch, form, symbols, leverageValues, accountType]);

  return symbolLeverage;
};
